const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/request.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/request.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AppRequestListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/request-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/request')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: AppRequestListFilterParamSchema,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});